import type { DownloadSettingsModalVariant } from '@/app/(main)/client-detail/types/downloadSettingsModalVariant';
import type { DownloadSettingsVariantCopy } from '../types';

const GROUPED_EXPORT_PASSPORT_COPY: DownloadSettingsVariantCopy['passportFiles'] = {
  label: 'Include passport scans in this PDF',
  description:
    'Uploaded passport images are embedded in the same PDF with your grouped tables (no zip). PDF uploads show a short note next to metadata.',
};

export const DOWNLOAD_SETTINGS_VARIANT_COPY: Record<DownloadSettingsModalVariant, DownloadSettingsVariantCopy> = {
  default: {
    title: 'Export client data',
    sectionsHeading: 'Choose the information to export',
    passportFiles: {
      label: 'Include passport files as separate PDFs',
      description:
        'Each uploaded passport will be exported as an individual PDF file in addition to the main client data export.',
    },
  },
  groupView: {
    title: 'Export group view',
    sectionsHeading: 'Choose the information to export',
    passportFiles: GROUPED_EXPORT_PASSPORT_COPY,
  },
  dashboardGrouped: {
    title: 'Export selected clients',
    sectionsHeading: 'Choose the information to export',
    passportFiles: GROUPED_EXPORT_PASSPORT_COPY,
  },
};

export function getDownloadSettingsCopy(variant: DownloadSettingsModalVariant): DownloadSettingsVariantCopy {
  return DOWNLOAD_SETTINGS_VARIANT_COPY[variant];
}
